namespace('compass.hotel');

compass.require('compass.hotel.StarRatingWidget');
compass.requireLib('compass.util.format');

compass.hotel.HotelShortInfoWidget = compass.defineWidget(function HotelShortInfoWidget(options) {
	var me = this;
	var $j = jQuery;

	var _settings = options;
	var _cf = compass.util.currencyFormatter(_settings.meetingInfo.currencyCode,
		{ showDecimals : 0, returnAsObject : true });
	var _maxRateDigits = 3;

	var _grabValues = this.grabValues = function() {
		var jsonValues = {};
		return jsonValues;
	};

	this.validate = function() {
		this.validator.validateAll();
		return this.validator.valid;
	};

	this.destroyWidget = function() {
	};

	/* HOTEL IMAGE */
	var _render = this.render = function(widgetElem) {
		var d = _d;
		var hotelType = _settings.hotel.avail.status == 'GDS' ? "web" : "event";
		var rate = (_settings.hotel.avail.inclusiveLowestAvgRateNumeric || _settings.hotel.avail.lowestAvgRateNumeric);
		var tbd = rate === 0 && _settings.showZeroRateAsTBD;

		var drawFormattedRate = function() {
			var rateDiv = d.div({className: 'averageNightlyRate '});
			if(tbd) {
				return rateDiv.addClass('tbd').append('TBD');
			} else  {
				var avgRate = _cf(Math.round((_settings.hotel.avail.inclusiveLowestAvgRateNumeric || _settings.hotel.avail.lowestAvgRateNumeric)));
				var avgRateSymbol = d.span({ className: 'averageNightlyRateSymbol' }, avgRate.symbol);

				// regex will match all digits in the string
				var matchDigits = /[0-9]/g;
				var rateClass = '';
				try{
					var rateClass = avgRate.value.match(matchDigits).length > _maxRateDigits ? 'largeRate' : '';
				} catch(ex){ }
				var avgRateValue = d.span({ className: 'averageNightlyRateValue ' + rateClass }, avgRate.value);
				return rateDiv.addClass('notbd ' + rateClass + ' notranslate').append(avgRateSymbol, avgRateValue);
			}
		};

		var rateMsg = ((_settings.hotel.avail.inclusiveLowestAvgRateNumeric || _settings.hotel.avail.lowestAvgRateNumeric) != _settings.hotel.avail.lowestAvgRateNumeric ? d.div({className:'ratedesc'},d.abbr({className : 'includesResortFee'},'*Rate includes mandatory hotel fee'))  : null);
		if (_settings.hotel.avail.isServiceFeeIncluded === true) rateMsg = d.div({className:'ratedesc'},d.abbr({className : 'includesResortFee'},'*Rate includes onPeak service fee.'));

		widgetElem.append(
			d.h2({className:'hotelName'}, _settings.hotel.hotelInfo.name),
			drawFormattedRate(),
			d.div({className: 'averageNightlyRateText'}, _settings.meetingInfo.currencyCode + ' | average nightly ' + hotelType + ' rate'),
			_settings.displayPriceSavings && this.drawPriceSavings(_settings.hotel),
			rateMsg,
			me.drawInlineDistanceAndOrRating(_settings.hotel)
		);
	};

	this.drawPriceSavings = function(hotel) {
		var d = _d;
		var compareAtPrice = Math.round(hotel.avail.lowestAvgRateNumeric / (1.0 - _settings.meetingInfo.priceSavingsPercent ));
		
		var linkDOM = d.span({className: 'priceSavingsExplanationLinkWrapper'}, 
			d.span({className: 'priceSavingsIcon'}, d.i({className:'fa-solid fa-dollar-circle'})),
			d.span({className: "priceSavingsExplanationLink"}, "Normally " + _settings.meetingInfo.currencySymbol + compareAtPrice)
		);

		linkDOM.activate(function() {
			compass.GA.trackEvent('Additional Information', 'Rate Comparison Description', 'Hotel Info');
			priceSavingsDialog = new compass.hotel.PriceSavingsExplanationWidget(null, {
				priceSavingsPercent: _settings.meetingInfo.priceSavingsPercent
			});
		});
		
		return linkDOM;
	};

	this.drawInlineDistanceAndOrRating = function(hotel) {
		var d = _d;
		var starRatingDisplay;
		if(hotel.hotelInfo.starRatingDecimal){
			starRatingDisplay = hotel.hotelInfo.starRatingDecimal;
		} else {
			starRatingDisplay = hotel.hotelInfo.starRating;
		}
		var starsWrapper = d.div({className: 'starsWidgetWrapper'});
		var _starRatingWidget = new compass.hotel.StarRatingWidget(starsWrapper, {stars : starRatingDisplay});
		var distanceDOM =  d.div({ className: 'hotelDistance'}, 
			d.div({className: 'label'}, "distance"),
			d.div({}, hotel.hotelInfo.distance, " ", hotel.hotelInfo.distanceUnits)
		);
		
		var starRatingDOM = d.div({ className: 'hotelStarRating'},
			d.div({className: 'label'}, "rating"),
			starsWrapper
		);
		return d.div({className: 'inlineDistanceAndOrRating'},
			!_settings.hideDistance && distanceDOM,
			_settings.displayHotelStars && starRatingDisplay > 0 && starRatingDOM
		);
	};

	var _d = jQuery.dom.getContext(this);

}, {
	WUID : 'CRAP',
	widgetName : 'HotelShortInfoWidget',
	name : 'Sheraton',
	distance : 10,
	showZeroRateAsTBD : false,
	displayHotelStars: true,
	displayPriceSavings: false
});

